import ptBR from './pt-BR'
import esES from './es-ES'
import enUS from './en-US'

export default {
  'pt-BR': ptBR,
  'es-ES': esES,
  'en-US': enUS
}
